import angular from 'angular';


const ngAvatar = angular.module('ttb.directives.ngAvatar', [])
    .directive('ngAvatar', () => {
        return {
            restrict: 'EA',
            scope: {
                url: '@',
                height: '@',
                fallback: '@',
            },
            template: `
                <span class="avatar-img__cropped">
                    <img ng-if="url" ng-src="{{url + '&size=c'}}" height="{{height || 30}}" width="{{height || 30}}" />
                    <i ng-if="!url" class="{{fallback}}" style="font-size: {{height || 30}}px"></i>
                </span>
                `
        };
    })
    .name;

export default ngAvatar;


// WEBPACK FOOTER //
// ../directives/ng-avatar.js